import {
  PaymentMethod,
  ReleasedByBusinessPolicyDTO,
} from '../../payment-method/payment-method.types';

export interface PaymentMethodReleasePolicies {
  visible?: ReleasedByBusinessPolicyDTO;
  hidden: ReleasedByBusinessPolicyDTO[];
}

export const getPaymentMethodSuffix = ({
  tagLabel,
  accumulatedInterestPercentage,
  orderDiscount,
}: PaymentMethod) => {
  if (tagLabel) {
    return tagLabel;
  }

  if (accumulatedInterestPercentage > 0) {
    return `+${accumulatedInterestPercentage}%`;
  }

  return orderDiscount > 0 ? `-${orderDiscount}%` : undefined;
};

export const formatOrderConditionPaymentMethod = (payment?: PaymentMethod) => {
  if (!payment) {
    return '';
  }

  const suffix = getPaymentMethodSuffix(payment);

  return suffix ? `${payment.name} (${suffix})` : payment.name;
};

export const getPaymentMethodReleasePolicies = (
  paymentMethod: PaymentMethod,
): PaymentMethodReleasePolicies => {
  const [visible, ...hidden] = paymentMethod.restrictToCommercialPolicies
    ? (paymentMethod.policies ?? [])
    : [];

  return { visible, hidden };
};

export const isPaymentMethodAvailable = (paymentMethod: PaymentMethod): boolean => {
  if (!paymentMethod.restrictToCommercialPolicies) {
    return true;
  }

  if (paymentMethod.policies?.length) {
    return true;
  }

  return (paymentMethod.commercialPolicies ?? []).some(
    (commercialPolicy) => commercialPolicy.available,
  );
};
